import { Grid } from '@mui/material';
import { PlannerPlansCalendar } from './PlannerPlansCalendar';
import { PlannerPlansHeader } from './PlannerPlansHeader';
import { PlannerPlansList } from './PlannerPlansList';

export const PlannerPlans = () => {
  return (
    <Grid container>
      <PlannerPlansHeader />

      <Grid
        container
        direction="column"
        wrap="nowrap"
        style={{ padding: `24px`, height: `calc(100vh - 98px)`, overflowY: `scroll` }}
      >
        <PlannerPlansCalendar />
        <PlannerPlansList />
      </Grid>
    </Grid>
  );
};
